export const DAT_CUOC_BC = 'DAT_CUOC_BC';
export const PLAY_GAME_BC = 'PLAY_GAME_BC';
export const AGAIN_GAME_BC = 'AGAIN_GAME_BC';